import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import masterApi from '../../api/masters'

export interface RootState {
    version: string;
}

export class product {
    id: number | undefined;
    name: string | undefined;
    source: string | undefined;
}

export class productType {
    value: number | undefined;
    text: string | undefined;

}
const state = Array<product>();
const getters: GetterTree<Array<product>, RootState> = {
    product(state: Array<product>) {
        return state
    }
};
export const mutations: MutationTree<Array<product>> = {
    LOAD_PROUDCT(state: Array<product>, products: Array<product>) {
        state.length=0;
        products.forEach(element => {
            state.push(element)
        });
    },
    CLEAR_PROUDCT(state: Array<product>) {
        state.length = 0
    }
};
const actions: ActionTree<Array<product>, RootState> = {
    async getProducts({ state, commit }: { commit: Commit, state: Array<product> }): Promise<Array<productType>> {
        if (state && state.length > 0) {

            const products: productType[] | PromiseLike<productType[]> = [];
            state.forEach((e) => {
                const f = products.find(f => f.text == e.source);
                if (!f) {
                    products.push({ text: e.source, value: e.id })
                }
            })
            return products;
        }
        try {
            const response = await masterApi.getProducts()
            if (response && response.data && response.data.resultType === 200) {
                const products: productType[] | PromiseLike<productType[]> = [];
                response.data.payload.forEach((e: { source: string; id: number; }) => {
                    const f = products.find(f => f.text == e.source);
                    if (!f) {
                        products.push({ text: e.source, value: e.id })
                    }
                })

                commit('LOAD_PROUDCT', response.data.payload)
                return products;
            }
            else {
                commit('CLEAR_PROUDCT')
                return Array<productType>();
            }
        }
        catch (error) {
            commit('CLEAR_PROUDCT')
            return Array<productType>();
        }
    },
    async getProductTypes({ state, commit }: { commit: Commit, state: Array<product> }): Promise<Array<product>> {
        if (state && state.length > 0) return state;
        try {
            const response = await masterApi.getProducts()
            if (response && response.data && response.data.resultType === 200) {
                commit('LOAD_PROUDCT', response.data.payload)
                return response.data.payload;
            }
            else {
                commit('CLEAR_PROUDCT')
                return state;
            }
        }
        catch (error) {
            commit('CLEAR_PROUDCT')
            return state;
        }
    },
    async getMaterialCodes({ state }: { commit: Commit, state: Array<product> }): Promise<Array<product>> {
        try {
            const response = await masterApi.getProductTypes()
            if (response && response.data && response.data.resultType === 200) {
                return response.data.payload;
            }
            else {
                return state;
            }
        }
        catch (error) {
            return state;
        }
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}